import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SidePanel } from "../../../FuturebilityCockpit/components/SidePanel";
import { CountdownTimer } from "../countdown-timer";
import { CloseIcon, InfoIcon } from "./icons";
import "./style.scss";

export interface HeaderSolutionProps {
  countdownTime: number;
  topLabels?: (string | string[])[];
  sidePanelContent?: string;
}

export function HeaderSolution({
  countdownTime,
  topLabels = [],
  sidePanelContent,
}: HeaderSolutionProps) {
  const { t } = useTranslation();
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  return (
    <>
      <header className="tg_header module3">
        <div className="header-content tg_column">
          <div className="info-section">
            <CountdownTimer countdownTime={countdownTime} />
            <InfoIcon onClick={() => setIsInfoOpen(!isInfoOpen)} />
          </div>
          <div className="top-labels">
            {topLabels.map((label, index) => (
              <div className="col" key={index}>
                {Array.isArray(label)
                  ? label.map(l => <div key={l}>{l}</div>)
                  : label}
              </div>
            ))}
          </div>
        </div>
      </header>
      {isInfoOpen && (
        <SidePanel active={true} direction="right">
          <div className="header-side-panel">
            <div className="top-row">
              <InfoIcon />
              <CloseIcon onClick={() => setIsInfoOpen(!isInfoOpen)} />
            </div>
          </div>
          {sidePanelContent && (
            <>
              <div className="info-header">
                {t(
                  "frontend.test.solutionInfoHeader.title",
                  "Assistance to answer the central question"
                )}
              </div>
              <div dangerouslySetInnerHTML={{ __html: sidePanelContent }} />
            </>
          )}
        </SidePanel>
      )}
    </>
  );
}
